import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/affiliate")({
  component: () => <Outlet />,
  head: () => ({ meta: [
    { title: "Inquira Affiliate Portal" },
    { name: "description", content: "Manage your Inquira affiliate account, referrals and payouts." },
    { property: "og:title", content: "Inquira Affiliate Portal" },
    { property: "og:description", content: "Manage your Inquira affiliate account, referrals and payouts." },
    { property: "og:type", content: "website" },
    { name: "twitter:card", content: "summary" },
  ] }),
});